import { createSlice } from '@reduxjs/toolkit';

import { fetchMagicCodes } from './magic-codes.thunks';
import { MagicCodeState } from './magic-codes.types';

export const magicCodeInitialState: MagicCodeState = {
  metadata: {
    loading: false,
    error: null,
  },
  magicCodesList: [],
};

export const { actions: magicCodesActions, reducer: magicCodeReducer } = createSlice({
  name: 'magicCodes',
  initialState: magicCodeInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMagicCodes.pending, (state) => {
      return {
        ...state,
        metadata: {
          loading: true,
          error: null,
        },
      };
    });
    builder.addCase(fetchMagicCodes.fulfilled, (state, { payload }) => {
      return {
        ...state,
        magicCodesList: payload,
        metadata: {
          loading: false,
          error: null,
        },
      };
    });
    builder.addCase(fetchMagicCodes.rejected, (state) => {
      return {
        ...state,
        metadata: {
          loading: false,
          error: 'error fetching magic codes',
        },
      };
    });
  },
});
